// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { NotificationPayload } from '@client-hub/store/slices/notifications/types'
import { crsApi } from './react'

const notifications: NotificationPayload<typeof crsApi.endpoints>[] = [
  {
    endpoint: crsApi.endpoints.manageProfile,
    tKey: 'profileUpdate',
  },
  {
    endpoint: crsApi.endpoints.verifyMfaCode,
    tKey: 'invalidOTP',
  },
  {
    endpoint: crsApi.endpoints.editTeamMember,
    tKey: 'editTeamMember',
  },
  {
    endpoint: crsApi.endpoints.addTeamMember,
    tKey: 'addTeamMember',
  },
  {
    endpoint: crsApi.endpoints.forgotPassword,
    tKey: 'forgotPassword',
  },
  {
    endpoint: crsApi.endpoints.resetPassword,
    tKey: 'resetPassword',
  },
  {
    endpoint: crsApi.endpoints.deleteTeamMember,
    tKey: 'deleteTeamMember',
  },
]

export default notifications
